const state = {
    actions: [],
    isPublic: true
};

const getters = {};

const actions = {
    setAntiForgeryToken
};


function setAntiForgeryToken({ commit, state, dispatch }, { headers }) {
    if (headers.requestverificationtoken) {
        commit('setAntiForgeryToken', {
            antiForgeryToken: headers.requestverificationtoken
        });
    }
}

// mutations
const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
